<div class="container_width">
    <div class="w-full flex flex-column gap-3">
        <div class="grid">
            <h1 class="text-left col-10 font-bold text-4xl">Scheduled Calls</h1>
            <!-- <p-button icon="pi pi-user-plus" (click)="showDialog()" label="Add Admin" class="col-2 flex flex-column gap-1" styleClass="submitBtn" /> -->
        </div>
      <!-- <div class="w-full flex flex-column gap-3">
        <h2 class="text-left font-medium text-2xl" style="color: #303030;"></h2>
        <div class="grid">
          <div class="col-3 flex flex-column gap-1">
            <b class="font-regular text-base" style="color: #505050;">From Date</b>
            <p-calendar placeholder="From date" [(ngModel)]="fromDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
              class="w-full" styleClass="fullWidth" />
          </div>
          <div class="col-3 flex flex-column gap-1">
            <b class="font-regular text-base" style="color: #505050;">To Date</b>
            <p-calendar placeholder="To Date" [(ngModel)]="toDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
              class="w-full" styleClass="fullWidth" />
          </div>
          <div class="col-3 flex flex-column gap-1">
            <b class="font-regular text-base" style="color: #505050;">State</b>
            <p-dropdown [options]="adminStateOptions" styleClass="selectFull" class="w-full" optionLabel="name"
              optionValue="value" [(ngModel)]="adminState" filterBy="name" [showClear]="true"
              appendTo="body" placeholder="Select Admin-State">
              <ng-template pTemplate="selectedItem" let-selectedOption>
                <div class="flex align-items-center gap-2">
                  <div>{{ selectedOption.name }}</div>
                </div>
              </ng-template>
              <ng-template let-option pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div>{{ option.name }}</div>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <div class="col-3">
            <div class="w-full" style="padding-top: 23px;">
              <p-button (click)="getAdmins(1)" label="Search" class="w-full" styleClass="submitBtn" />
            </div>
          </div>
        </div>
      </div> -->
      <form [formGroup]="meetingUrlForm" (ngSubmit)="onSubmit()">
        <div class="w-full">
          <p-table  *ngIf="meetingList && meetingList.length > 0; else noRecordsFound" [value]="meetingList"
            [paginator]="meetingList.length!=totalRecords" [rows]="rowSize" [totalRecords]="totalRecords" [first]="first" [lazy]="true"
            [lazyLoadOnInit]="false" [loading]="isLoading" [loadingIcon]="'pi pi-spinner'"
            (onLazyLoad)="onLazyLoad($event)" [rowsPerPageOptions]="[10, 20, 30]" [showPageLinks]="true"
            styleClass="p-datatable-gridlines tableCon" [tableStyle]="{ 'min-width': '50rem' }">
            <ng-template pTemplate="header">
              <tr>
                <th>Student Name</th>
                
                <th>Email</th>
                <th>Date</th>
                <th>Purpose</th>
                <th>Meeting Url</th>
                <th>Send via Email</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-student let-i="rowIndex">
    
              <tr>
                <td>{{student.firstName}} {{student.lastName}}</td>
              
                <td>{{student.email}}</td>
                <td>{{student.date}}</td>
                <td>{{student.purpose}}</td>
                  <td>
                    <textarea class="w-full" style="border: 1px solid #CCD7E7; border-radius: 4px; padding: 8px; box-sizing: border-box;"
                      rows="2"
                      cols="10"
                      pInputTextarea 
                      [formControl]="getFormControl(i)">
                    </textarea>
                  </td>
                  <td>
                    <p-button (click)="onSendMeetingUrl(i)" label="Send Email" icon="pi pi-envelope" styleClass="viewapplication" />
                  </td>
              </tr>
            </ng-template>
          </p-table>
          <ng-template #noRecordsFound>
            <div class="w-full flex flex-column align-items-center py-4 gap-5">
              <div class="w-full flex align-items-center justify-content-center">
                <img src="../../../assets/icons/nodatafound.svg" alt="" class="w-full max-w-16rem">
              </div>
              <b class="text-center font-normal text-2xl" style="color: #000086;">No Data Found !</b>
            </div>
          </ng-template>
        </div>
      </form>

    </div>
  </div>

